import React from 'react'
import Grid from '@mui/material/Grid';
import Slider from '@mui/material/Slider';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';



class Filter extends React.Component {
    render() {
        var filterHeadingStyle = {
            textAlign:"left"
          }
    return (
        <div>            

            <Grid container padding={2}>
                <Grid item xs={12}>
                    <h2 style={filterHeadingStyle}>Filters</h2>
                </Grid>
                <h4> Max Price ($) </h4>
                <Slider style={{color:'#000000'}} defaultValue={200000} min={10000} max={200000} aria-label="Default" valueLabelDisplay="auto" onChange={(event, value) => this.props.filterHandleFunction("price")({ target: { value } })} />
                <h4> Minimum Electric Range (mi) </h4>
                <Slider style={{color:'#000000'}} defaultValue={0} min={0} max={500}aria-label="Default" valueLabelDisplay="auto" onChange={(event, value) => this.props.filterHandleFunction("range")({ target: { value } })}/>
                <h4> Minimum Battery Size (kWh) </h4>
                <Slider style={{color:'#000000'}} defaultValue={0} min={0} max={100}aria-label="Default" valueLabelDisplay="auto" onChange={(event, value) => this.props.filterHandleFunction("batterySize")({ target: { value } })}/>
                <h4> Minimum Number of Seats </h4>
                <Slider style={{color:'#000000'}} defaultValue={0} min={0} max={6}aria-label="Default" valueLabelDisplay="auto" onChange={(event, value) => this.props.filterHandleFunction("seatNumber")({ target: { value } })} />

                <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group"  defaultValue="All" onChange={(event, value) => this.props.filterHandleFunction("typeOfCar")({ target: { value } })} style={{paddingTop:'20px'}}>
                    <FormControlLabel value="All" control={<Radio />} label="All" />
                    <FormControlLabel value="Electric" control={<Radio />} label="Electric" />
                    <FormControlLabel value="Hybrid" control={<Radio />} label="Hybrid" />
                </RadioGroup>
            </Grid>
        </div>
        )
    }
}


export default Filter;